import React from 'react';
import PropTypes from 'prop-types';
import ErrorNotification from './ErrorNotification';

const CustomInputComponent = ({
	className,
	placeholder,
	name,
	formik,
	...props
}) => {
	return (
		<div>
			<label htmlFor={name} className="label">
				{placeholder}
				<input
					type="text"
					className={className}
					placeholder={placeholder}
					name={name}
					{...props}
				/>
			</label>
			<ErrorNotification formik={formik} field={name} />
		</div>
	);
};

CustomInputComponent.propTypes = {
	name: PropTypes.instanceOf(String).isRequired,
	formik: PropTypes.instanceOf(Object).isRequired,
	placeholder: PropTypes.instanceOf(String).isRequired,
	className: PropTypes.instanceOf(String).isRequired,
};

export default CustomInputComponent;
